import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper _flex _jc-c _mt-8" }
const _hoisted_2 = { class: "gfu-2of3--m" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_unsubscribe_notification = _resolveComponent("unsubscribe-notification")
  const _component_unsubscribe_notification_confirmation = _resolveComponent("unsubscribe-notification-confirmation")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!$data.isUnsubscribeConfirmed)
        ? (_openBlock(), _createBlock(_component_unsubscribe_notification, {
            key: 0,
            "unsubscribe-confirmation-key": $props.unsubscribeConfirmationKey,
            "context-name": $props.contextName,
            topic: $props.topic,
            onUnsubscribe: $options.confirmUnsubscribe
          }, null, 8 /* PROPS */, ["unsubscribe-confirmation-key", "context-name", "topic", "onUnsubscribe"]))
        : (_openBlock(), _createBlock(_component_unsubscribe_notification_confirmation, {
            key: 1,
            "context-name": $props.contextName,
            topic: $props.topic
          }, null, 8 /* PROPS */, ["context-name", "topic"]))
    ])
  ]))
}